angular
    .module('webcomm')
    .factory(
        'activityService',
        ['$rootScope', '$log', 'channelModel','timeFormattingService',
            ($rootScope, $log, channelModel, timeFormattingService) => {
                var newActivities = 0;
                var activityCount = 0;
                var isVisible = false;
                const MAX_ACTIVITIES = 5000;

                var service = {
                    newActivityCount() {
                        return newActivities;
                    },
                    setVisible(visible) {
                        isVisible = visible;
                        if (isVisible) {
                            newActivities = 0;
                            $rootScope.$emit('timeForResize');
                        }
                    },
                    activities: []
                };

                function isPrivateMessage(channelId) {
                    return channelId <= 0;
                }

                // needs work for private call data
                function getGroupNameFromData(data) {
                    if(data.Self) {
                        return data.destination.displayName;
                    } else {
                        return "You";
                    }
                }

                function getChannelNameFromId(channelId) {
                    return channelModel.getChannel(channelId).name;
                }

                function addActivity(channelId, clientTime, eventType, name, message, data) {

                    var activity = {
                        id: activityCount++,
                        type: '',
                        time: timeFormattingService.formatFeedDate(clientTime),
                        name: name,
                        group: isPrivateMessage(channelId) && data ? getGroupNameFromData(data) : getChannelNameFromId(channelId),
                        groupId: channelId,
                        text: message
                    };

                    if(eventType === "end-speaking") {
                        activity.type = "audio";
                    } else if ( eventType.match('call-')) {
                        activity.type = "call";
                    } else {
                        activity.type = "text";
                    }

                    service.activities.unshift(activity);

                    // remove last element if we hit size limit
                    if (service.activities.length > MAX_ACTIVITIES) {
                        service.activities.pop();
                    }

                    if (!isVisible) {
                        newActivities++;
                    }
                }

                $rootScope.$on('feedModel.feedEventReceived', function(event, feedEvent) {
                    //$log.info('activity - feedEventReceived', feedEvent);
                    switch(feedEvent.type) {
                        case "text-message":
                            addActivity(
                                feedEvent.channelId,
                                feedEvent.clientTime,
                                feedEvent.type,
                                feedEvent.name,
                                feedEvent.data.message,
                                feedEvent.data.messageData
                            );
                            break;
                        case "end-speaking":
                        case "call-started":
                            addActivity(
                                feedEvent.channelId,
                                feedEvent.clientTime,
                                feedEvent.type,
                                feedEvent.name,
                                feedEvent.data.message
                            );
                            break;
                        case "call-offer":
                            addActivity(
                                feedEvent.channelId,
                                feedEvent.clientTime,
                                feedEvent.type,
                                feedEvent.name,
                                'Trying to call ',
                                feedEvent.data.callerInfo
                            );
                            break;
                    }
                });

                $rootScope.$on('ConnectionService.logout', (event, data) => {
                    newActivities = 0;
                    service.activities = [];
                });

                $log.debug('activityService initialized');
                return service;
            }
        ]);